export const exhibitionMapConstants = {
    ROOMS_LIST_REQUEST: "ROOMS_LIST_REQUEST",
    ROOMS_LIST_SUCCESS: "ROOMS_LIST_SUCCESS",
    ROOMS_LIST_FAILURE: "ROOMS_LIST_FAILURE",
    ROOMS_LIST_CLEAR: "ROOMS_LIST_CLEAR",
    MAP_CONFIG_CRUD_FAILURE: "MAP_CONFIG_CRUD_FAILURE"
};
